// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__zEWHD","productName":"Table_productName__1W6V0"};